export const APP_TITLE = 'Buky';
